import { useConfig } from './useConfig';
export function usePropsDefault(key) {
  var propsDefault = useConfig().propsDefault || {};
  return propsDefault[key] || {};
}